module.exports = {
  'lan': 'enTitle'
}
